import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class RebNgxDividerComponent {
    constructor() {
        /**
         * Margin top and bottom of the divider
         */
        this.marginHorizontal = 'none';
        /**
         * Margin left and right of the divider
         */
        this.marginVertical = 'none';
    }
    get classes() {
        return [
            `
      margin-horizontal--${this.marginHorizontal}
      margin-vertical--${this.marginVertical}
      `
        ];
    }
}
RebNgxDividerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
RebNgxDividerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.10", type: RebNgxDividerComponent, selector: "reb-ngx-divider", inputs: { marginHorizontal: "marginHorizontal", marginVertical: "marginVertical" }, ngImport: i0, template: "<hr class=\"rn-divider\" [ngClass]=\"classes\" />\n", styles: [".rn-divider{border:var(--border-stroke-1);border-color:var(--palette-grey-95);border-style:solid}\n"], directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'reb-ngx-divider', template: "<hr class=\"rn-divider\" [ngClass]=\"classes\" />\n", styles: [".rn-divider{border:var(--border-stroke-1);border-color:var(--palette-grey-95);border-style:solid}\n"] }]
        }], propDecorators: { marginHorizontal: [{
                type: Input
            }], marginVertical: [{
                type: Input
            }] } });

class RebNgxDividerModule {
}
RebNgxDividerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxDividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RebNgxDividerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxDividerModule, declarations: [RebNgxDividerComponent], imports: [CommonModule], exports: [RebNgxDividerComponent] });
RebNgxDividerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxDividerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.10", ngImport: i0, type: RebNgxDividerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RebNgxDividerComponent],
                    imports: [CommonModule],
                    exports: [RebNgxDividerComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { RebNgxDividerComponent, RebNgxDividerModule };
